import { TitleComponent } from '../shared/title/title.component';
import { AccountComponent } from '../shared/account/account.component';
import { LinkListComponent } from '../shared/link-list/link-list.component';
import { LargeLoginComponent } from '../fs/large-login/large-login.component';
import { LogoComponent } from '../shared/logo/logo.component';
import { CopyrightComponent } from '../shared/copyright/copyright.component';
import { PageTitleComponent } from '../shared/page-title/page-title.component';
import { DeviceListComponent } from '../fs/device-list/device-list.component';
import { OrderHistoryComponent } from '../fs/order-history/order-history.component';
import { OrderHistoryDetailComponent } from '../fs/order-history-detail/order-history-detail.component';
import { BreadcrumbComponent } from '../shared/breadcrumb/breadcrumb.component';
import { DeviceDetailComponent } from '../fs/device-detail/device-detail.component';
import { QuoteComponent } from '../fs/quote/quote.component';
import { OrderConfirmationComponent } from '../shared/order-confirmation/order-confirmation.component';
import { ParagraphComponent } from '../shared/paragraph/paragraph.component';
import { NavigationComponent } from '../shared/navigation/navigation.component';
import { LanguageSwitchComponent } from '../shared/language-switch/language-switch.component';
import { NwpAdminInviteComponent } from '../fs/nwp-admin-invite/nwp-admin-invite.component';
import { NwpUserListComponent } from '../fs/nwp-user-list/nwp-user-list.component';
import { NwpListComponent } from '../fs/nwp-list/nwp-list.component';
import { SignUpComponent } from '../fs/sign-up/sign-up.component';
import { HeroBannerComponent } from '../lr/hero-banner/hero-banner.component';
import { ProductSliderComponent } from '../lr/product-slider/product-slider.component';
import { NextStepComponent } from '../shared/next-step/next-step.component';
import { ErrorComponent } from '../shared/error/error.component';
import { PhoneComponent } from '../lr/phone/phone.component';
import { CustomerSupportComponent } from '../lr/customer-support/customer-support.component';
import { ProductDetailComponent } from '../lr/product-detail/product-detail.component';
import { BasketComponent } from '../lr/basket/basket.component';
import { CheckoutStepsComponent } from '../lr/checkout-steps/checkout-steps.component';
import { LoginCheckoutComponent } from '../lr/login-checkout/login-checkout.component';
import { CheckoutAddressComponent } from '../lr/checkout-address/checkout-address.component';
import { CheckoutDeliveryComponent } from '../lr/checkout-delivery/checkout-delivery.component';
import { CheckoutPaymentComponent } from '../lr/checkout-payment/checkout-payment.component';
import { CheckoutSummaryComponent } from '../lr/checkout-summary/checkout-summary.component';
import { SignUpCompleteComponent } from '../lr/sign-up-complete/sign-up-complete.component';
import { AccordionComponent } from '../lr/accordion/accordion.component';
import { SimpleTitleComponent } from '../lr/simple-title/simple-title.component';
import { ContactBoxComponent } from '../lr/contact-box/contact-box.component';
import { ContactFormComponent } from '../lr/contact-form/contact-form.component';
import { ContactConfirmationComponent } from '../lr/contact-confirmation/contact-confirmation.component';
import { SearchResultListComponent } from '../lr/search-result-list/search-result-list.component';
import { CategoryListComponent } from '../lr/categoriy-list/category-list.component';
import { ContactComponent } from '../lr/contact/contact.component';
import { TitledParagraphComponent } from '../lr/titled-paragraph/titled-paragraph.component';
import { PaymentIconsComponent } from '../lr/payment-icons/payment-icons.component';
import { SearchResultTitleComponent } from '../lr/search-result-title/search-result-title.component';
import { SearchNoResultComponent } from '../lr/search-no-result/search-no-result.component';
import { TeaserComponent } from '../lr/teaser/teaser.component';
import {ListItemComponent} from "../fs/list-item/list-item.component";
import { SeoAccordionComponent } from '../lr/seo/seo-accordion/seo-accordion.component';
import { SeoContentComponent } from '../lr/seo/seo-content/seo-content.component';
import { PromotionBannerComponent } from '../lr/promotion-banner/promotion-banner.component';
import {NetworkPartnerPrivacyPolicyComponent} from "../lr/network-partner-privacy-policy/network-partner-privacy-policy.component";
import {NetworkPartnerTermsAndConditionComponent} from "../lr/network-partner-terms-and-condition/network-partner-terms-and-condition.component";

export const componentMapping = {
  KionSiteTitleComponent: TitleComponent,
  KionMyAccountComponent: AccountComponent,
  KionLinkListComponent: LinkListComponent,
  KionLargeLoginComponent: LargeLoginComponent,
  KionLogoComponent: LogoComponent,
  KionCopyrightComponent: CopyrightComponent,
  KionPageTitleComponent: PageTitleComponent,
  KionDeviceListComponent: DeviceListComponent,
  KionOrderHistoryComponent: OrderHistoryComponent,
  KionOrderHistoryDetailComponent: OrderHistoryDetailComponent,
  BreadcrumbComponent: BreadcrumbComponent,
  KionDeviceDetailComponent: DeviceDetailComponent,
  KionQuoteComponent: QuoteComponent,
  KionOrderConfirmationComponent: OrderConfirmationComponent,
  KionParagraphComponent: ParagraphComponent,
  KionNavigationComponent: NavigationComponent,
  KionLanguageSwitchComponent: LanguageSwitchComponent,
  KionInviteAdminComponent: NwpAdminInviteComponent,
  KionUserInvitationListComponent: NwpUserListComponent,
  KionNwpListComponent: NwpListComponent,
  KionUserRegistrationComponent: SignUpComponent,
  KionHeroBannerComponent: HeroBannerComponent,
  KionProductSliderComponent: ProductSliderComponent,
  KionTitledNextStepComponent: NextStepComponent,
  KionErrorComponent: ErrorComponent,
  KionSitePhoneComponent: PhoneComponent,
  KionCustomerSupportComponent: CustomerSupportComponent,
  ProductDetailComponent: ProductDetailComponent,
  KionReferenceProductSliderComponent: ProductSliderComponent,
  KionCartComponent: BasketComponent,
  KionCheckoutStepsComponent: CheckoutStepsComponent,
  KionLoginCheckoutComponent: LoginCheckoutComponent,
  KionCheckoutAddressComponent: CheckoutAddressComponent,
  KionCheckoutDeliveryComponent: CheckoutDeliveryComponent,
  KionCheckoutPaymentComponent: CheckoutPaymentComponent,
  KionCheckoutSummaryComponent: CheckoutSummaryComponent,
  KionCompleteRegistrationComponent: SignUpCompleteComponent,
  KionAccordionComponent: AccordionComponent,
  KionSimpleTitleComponent: SimpleTitleComponent,
  KionContactBoxComponent: ContactBoxComponent,
  KionContactFormComponent: ContactFormComponent,
  KionContactConfirmationComponent: ContactConfirmationComponent,
  KionSearchResultsListComponent: SearchResultListComponent,
  KionProductCategoriesComponent: CategoryListComponent,
  KionContactComponent: ContactComponent,
  KionTitledParagraphComponent: TitledParagraphComponent,
  KionImageLinkListComponent: PaymentIconsComponent,
  KionSearchResultPageTitleComponent: SearchResultTitleComponent,
  KionSearchNoResultComponent: SearchNoResultComponent,
  KionNextStepComponent: NextStepComponent,
  KionUspComponent: NextStepComponent,
  KionTeaserComponent: TeaserComponent,
  KionListItemComponent: ListItemComponent,
  KionSeoBlockAccordionComponent: SeoAccordionComponent,
  KionSeoBlockContentComponent: SeoContentComponent,
  KionBannerComponent: PromotionBannerComponent,
  KionNetworkPartnerTermsAndConditionsComponent: NetworkPartnerTermsAndConditionComponent,
  KionNetworkPartnerPrivacyPolicyComponent: NetworkPartnerPrivacyPolicyComponent
};
